/* eslint-disable no-shadow */
export enum UserType {
	ADMIN = 'ADMIN',
	CLIENT = 'CLIENT',
	DRIVER = 'DRIVER',
}
